var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("流程图")]),_c('div',{ref:"mountNode",attrs:{"id":"mountNode"}})])}
var staticRenderFns = []

export { render, staticRenderFns }